module.exports = __webpack_public_path__ + "static/media/dashboardLightActive.6e946411.svg";